//建筑能效系统

export default [{
		//首页
		path: '/overView',
		name: 'overView',
		component: () =>
			import('@/page/system/EnergyEfficiencySystem/page/BEEhome.vue')
	}, {
		//分项能耗概况
		path: '/subOptionElect',
		name: 'subOptionElect',
		component: () =>
			import('@/page/system/EnergyEfficiencySystem/page/subOptionElect.vue')
	},
	{
		//分项能耗统计
		path: '/IECanalysis',
		name: 'IECanalysis',
		component: () =>
			import('@/page/system/EnergyEfficiencySystem/page/IECanalysis.vue')
	},{
		//分项能耗分析
		path: '/IECstatistics',
		name: 'IECstatistics',
		component: () =>
			import('@/page/system/EnergyEfficiencySystem/page/IECstatistics.vue')
	},
	{
		//能流图
		path: '/energyFlowConfig',
		name: 'energyFlowConfig',
		component: () =>
			import('@/page/energyFlow/energyFlowConfig.vue')
	}, {
		//能耗排名
		path: '/ECramk',
		name: 'ECramk',
		component: () =>
			import('@/page/system/EnergyEfficiencySystem/page/ECramk.vue')
	},
]